import clsx from "clsx";
import React from "react";

interface CreditBadgeProps {
    title: string;
    color: string;
}

const CreditBadge = (props: CreditBadgeProps) => {
    return (
        <span className={clsx("text-xxs font-bold  px-2 py-1 rounded-full", props.color, props.color == "bg-arbo-red" ? "text-white" : "text-black")}>
            {props.title}
        </span>
    );
};

export default CreditBadge;
